import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";

export default function card() {
  return (
    <div>
      {" "}
      <Grid container spacing={3}>
        {" "}
        <Grid size={3}>
          {" "}
          <Card>
            <CardMedia
              sx={{ height: 140 }}
              image="img/servicios/facturaE.svg"
              title="Facturación electrónica"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                className="titleService"
              >
                Facturación electrónica
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Consiste en generar un documento equivalente electrónico a la
                factura que se genera, valida, recibe y se conserva mediante
                sistemas informáticos con la previa validación de la DIAN.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={3}>
          {" "}
          <Card>
            <CardMedia
              sx={{ height: 140 }}
              image="img/servicios/soporteE.svg"
              title="Documento soporte electrónico"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                className="titleService"
              >
                Documento soporte electrónico
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Módulo en el cual, puede elaborar y generar un documento que
                soporta la compra de un bien o la prestación de un servicio
                cuando el proveedor es un sujeto no obligado a expedir factura
                electrónica.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={3}>
          {" "}
          <Card>
            <CardMedia
              sx={{ height: 140 }}
              image="img/servicios/nominaE.svg"
              title="Nómina electrónica"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                className="titleService"
              >
                Nómina electrónica
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Consiste en generar el documento Soporte de Pago de Nomina
                Electrónica, soporte de los costos y deducciones en el impuesto
                sobre la renta y complementarios e impuestos descontables del
                IVA – Cuando aplique – se deriva de los pagos o abonos en cuenta
                relacionados con la nómina que se desprenden de una relación
                laboral, de pensiones o legal y reglamentaria.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={3}>
          {" "}
          <Card>
            <CardMedia
              sx={{ height: 140 }}
              image="img/servicios/eventR.svg"
              title="Eventos RADIAN"
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                className="titleService"
              >
                Eventos RADIAN
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Módulo que le permite administrar el registro, consulta y
                trazabilidad de las facturas Electrónicas de venta como titulo
                valor (facturas a crédito) y en el cual, puede realizar el acuse
                de recibo, la recepción de bienes, la aceptación expresa o el
                rechazo de la facturas electrónicas recibidas.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
